// angular
// .module("HeroPRO")
// .factory("coachmark", coachmarkFactory);


import _ from 'lodash';
import hopscotch from 'hopscotch';

import './coachmark.scss';

/* @ngInject */
export default function coachmarkFactory($http, $templateCache, $analytics, localStorageService, $window) {
    let templateMarkup,
        template;

    getCoachmarkMarkup();

    function getCoachmarkMarkup() {
        templateMarkup = $templateCache.get('app/common/coachmark/coachmarkDefaultTemplate.html');

        if (templateMarkup !== undefined) {
            template = _.template(templateMarkup);
        } else {
            $http.get('app/common/coachmark/coachmarkDefaultTemplate.html').then((templateMarkup) => {
                template = _.template(templateMarkup.data);
            });
        }
    }

    function setCoachmarkTemplate() {
        hopscotch.templates.hpTemplate = function (data) {
            return template(data);
        };

        hopscotch.setRenderer('hpTemplate');
    }

    function hideActionItemButtonGroup() {
        const actionItemContextMenu = $window.document.querySelector('.action-item:first-child .btn-group');

        if (actionItemContextMenu !== null && actionItemContextMenu.classList) {
            actionItemContextMenu.classList.remove('open');
        }
    }

    function getTourConfig() {
        const steps = [];

        if (document.getElementById('navbar-brand-coach-target')) {
            steps.push({
                title: 'Switch between HERO and Benji',
                content: '<p>Easily switch between HERO and Benji by clicking the logo in the corner.</p>',
                target: '.navbar-brand',
                placement: 'right',
                xOffset: 60,
                yOffset: 50,
                onShow() {
                    document.getElementById('navbar-brand-coach-target').click();
                },
                onNext() {
                    localStorageService.set('lastCoachmarkViewed', hopscotch.getCurrStepNum());
                },
            });
        }

        steps.push({
            title: 'Contact Us',
            content: '<p>Have any questions? Our customer service experts are available to assist you.</p>',
            target: '.topNav-contact-info',
            placement: 'left',
            xOffset: -240,
            yOffset: 105,
            onShow() {
                document.getElementById('topNav-contact-info-coach-target').click();
            },
            onNext() {
                localStorageService.set('lastCoachmarkViewed', hopscotch.getCurrStepNum());
            },
        });

        steps.push({
            title: 'Account Details',
            content: '<p>This menu links to your account information.</p>',
            target: '.topNav-user-info',
            placement: 'left',
            xOffset: -260, // getUserDropdownXCoordinate(),
            yOffset: 57,
            onShow() {
                document.getElementById('topNav-user-info-coach-target').click();
            },
            onNext() {
                localStorageService.set('lastCoachmarkViewed', hopscotch.getCurrStepNum());
            },
        });

        steps.push({
            title: 'Company Pipeline',
            content: '<p>Here is a summary of your projects. Additional metrics are also provided to show you the health of your HERO pipeline.</p>',
            target: '.hp-module:nth-child(2) h1',
            placement: 'top',
            xOffset: 60,
            arrowOffset: 30,
        });


        return {
            id: 'heropro-coachmark',
            i18n: {
                nextBtn: 'Got It',
            },
            customData: {
                dismissText: 'Skip this tour',
            },
            onEnd() {
                hideActionItemButtonGroup();


                localStorageService.set('preventAutoCoachmark', true);
                hopscotch.endTour(true);
            },
            onClose() {
                hideActionItemButtonGroup();

                $analytics.eventTrack('Dismiss', { category: 'Coachmark', label: `${hopscotch.getCurrStepNum()}/${hopscotch.getCurrTour().steps.length}` });
                hopscotch.endTour(true);
            },
            onNext() {
                localStorageService.set('lastCoachmarkViewed', hopscotch.getCurrStepNum());
            },
            steps,
        };
    }

    return {
        startCoachmarkTour(autoStart) {
            if (autoStart) {
                if (!localStorageService.get('preventAutoCoachmark')) {
                    setCoachmarkTemplate();
                    hopscotch.startTour(getTourConfig(), localStorageService.get('lastCoachmarkViewed'));
                    $analytics.eventTrack('AutoShow', { category: 'Coachmark', label: `${hopscotch.getCurrStepNum()}/${hopscotch.getCurrTour().steps.length}` });
                }
            } else {
                setCoachmarkTemplate();
                hopscotch.startTour(getTourConfig());
                $analytics.eventTrack('Manual Launch', { category: 'Coachmark' });
            }
        },

        endCoachmarkTour() {
            hopscotch.endTour(true);
            // Set preventAutoCoachmark to false since this function is only called when a user navigates to a different page
            localStorageService.set('preventAutoCoachmark', false);
        },

        getCurrTour() {
            return hopscotch.getCurrTour();
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/common/coachmark/coachmarkFactory.js